import {LocationContext} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Text} from "@mantine/core";
import {InfoWindow, InfoWindowProps} from "../InfoWindow/InfoWindow";
import {InfoWindowBody} from "../InfoWindowBody/InfoWindowBody";
import {EntityAnchor} from "../../../anchor/EntityAnchor/EntityAnchor";

export type LocationContextInfoWindowProps = Omit<InfoWindowProps, 'children'> & {
  ctx: LocationContext
  /** Off where the app has no profile to open, e.g. HubGo: the name reads as plain text. */
  linkEntity?: boolean
}

// The truck icon is 37px tall and its load badge reaches 44px above the anchor.
const UNIT_WINDOW_LIFT = 48;

export const LocationContextInfoWindow = (props: LocationContextInfoWindowProps) => {
  const {ctx, linkEntity = true, options, position, ...rest} = props;

  const {t} = useTranslation("common");

  return (
    <InfoWindow
      {...rest}
      // On the unit rather than where the cursor came in, and lifted clear of the marker and its load badge, so the
      // window never opens under the cursor: that fired the marker's mouseout, closed it, and it flickered.
      position={ctx.location ? {lat: ctx.location.latitude, lng: ctx.location.longitude} : position}
      options={{
        ...options,
        pixelOffset: options?.pixelOffset ?? new google.maps.Size(0, -UNIT_WINDOW_LIFT)
      }}>
      <InfoWindowBody>
        <div>
          {linkEntity
            ? <EntityAnchor
              value={{
                objectId: ctx.entityId,
                objectName: ctx.entityName,
                objectType: ctx.entityType,
              }}
            />
            : <Text fw={600}>{ctx.entityName}</Text>}
          <Text>{ctx.companyName ?? "-"}</Text>
        </div>
      </InfoWindowBody>
    </InfoWindow>
  )
};
